import { render, staticRenderFns } from "./jxstulist.vue?vue&type=template&id=332f628e&scoped=true"
import script from "./jxstulist.vue?vue&type=script&lang=js"
export * from "./jxstulist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f628e",
  null
  
)

export default component.exports